// Vue & Plugins
import { ref } from 'vue'
import { defineStore, acceptHMRUpdate } from 'pinia'

// Models
import { DEFAULT_PER_PAGE } from '../common/models/pagination'

export const useNotificationFilterStore = defineStore(
    'NotificationFilterStore',
    () => {
        const perPage = ref(DEFAULT_PER_PAGE)
        const page = ref(1)

        return {
            perPage,
            page,
        }
    },
)

if (import.meta.hot !== null && import.meta.hot !== undefined) {
    import.meta.hot.accept(
        acceptHMRUpdate(
            useNotificationFilterStore,
            import.meta.hot,
        ),
    )
}
